<template>
    <div class="products-items-container">
        <div v-for="product in products" :key="product.id" class="product-card-container" >
            
            <Productcard :product=product></Productcard>
        </div>
    </div>
</template>
<script>
import Productcard from "@/components/Productcard.vue";
export default {
    name: "Newestproducts",
    components: {
        Productcard
    },
    props: {
        products: Array,
    },
}
</script>

<style lang="scss" scoped>  
    .products-items-container{
        width: 100%;
        display: grid;
        // grid-template-columns: repeat(auto-fit, minmax(240px , 1fr));
        grid-auto-rows: 1fr;
        grid-gap: 16px;
        

        .product-card-container{
            height: 100%;
        }
    }

    @media only screen and (min-width: 600px) {
        .products-items-container{
            grid-template-columns: repeat(auto-fit, minmax(240px , 1fr));
        }
    }

    @media only screen and (max-width: 559px) {
        .products-items-container{
            grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
        }
    }
</style>
